import Vue from 'vue'
import Router from 'vue-router'
import Features from '@/containers/Features'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Features',
      component: Features
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.fullPath.indexOf('/#/') !== -1) next(to.fullPath.replace('/#/', '/'))
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js